window.Popper = require('popper.js').default;
require('bootstrap');
window.Vue = require('vue');


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js